import axios from "axios"

export const isValidPostcode = postcode => {
  if (!postcode) return false

  // Remove spaces for uniform validation
  const sanitisedPostcode = postcode.replace(/\s/g, "")

  // Define regex patterns for different locales
  const postcodePatterns = {
    gb: /^[A-Z]{1,2}[0-9]{1,2}[A-Z]? ?[0-9][A-Z]{2}$/i,
    es: /^\d{5}$/,
    us: /^\d{5}(-\d{4})?$/,
    it: /^\d{5}$/,
  }

  const locale = process.env.GATSBY_LOCALE?.toLowerCase()

  return postcodePatterns[locale]?.test(sanitisedPostcode) ?? false
}

/**
 * Get location from postcode
 * @link https://nominatim.org/release-docs/latest/api/Search/
 * @param postcode
 * @returns {Array}
 */
export const getLocationFromPostcode = async postcode => {
  const req = await axios.get(
    `https://nominatim.openstreetmap.org/search?postalcode=${postcode}&format=json&limit=1&country=${process.env.GATSBY_LOCALE || "gb"}`,
  )

  return req?.data[0]
}

export const loadLocations = async (storeGroup, lat, lng) => {
  const req = await axios.get(
    `https://${process.env.GATSBY_WORDPRESS_BASE_URL}/wp-json/wp/v2/location?lat=${lat}&lng=${lng}${storeGroup ? "&store_group=" + storeGroup : ""}`,
  )

  return req?.data
}

export const getGeodesicDistance = (lat1, lon1, lat2, lon2) => {
  function deg2rad(deg) {
    return deg * (Math.PI / 180)
  }
  const R = 6371 // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1) // deg2rad below
  const dLon = deg2rad(lon2 - lon1)
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c // Distance in km
  return d.toFixed(1)
}
